/* EZ Rides: Service & repairs page (sections/ez-service.liquid).
   - The RepairShopr form is a cross-origin iframe, so the page can't read its
     height. It starts snug for step 1; every later load of the iframe (Next,
     Back, a validation error, the thank-you page) switches to the taller
     "later steps" height and brings the card back into view.
   - The iframe's inline onload counts loads in data-loads, so a load that
     happens before this deferred file runs is not missed.
   - Links to #ez-sv-faq-* open that FAQ row. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onFrameLoad(iframe) {
    var frame = iframe.closest('[data-ez-sv-frame]');
    if (!frame) return;
    var loads = +iframe.getAttribute('data-loads') || 0;
    frame.classList.remove('is-slow');
    frame.classList.add('is-ready');
    if (loads > 1) {
      frame.classList.add('is-step');
      var card = frame.closest('[data-ez-sv-ticket]');
      if (card) {
        var top = card.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.5) {
          card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }
  }

  window.EZService = { loaded: onFrameLoad };

  function openFaq(hash) {
    if (!hash || hash.indexOf('#ez-sv-faq-') !== 0) return false;
    var item = document.getElementById(hash.slice(1));
    if (!item) return false;
    item.open = true;
    item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    var summary = item.querySelector('summary');
    if (summary) summary.focus({ preventScroll: true });
    return true;
  }

  function init() {
    document.querySelectorAll('[data-ez-sv-frame] iframe').forEach(function (iframe) {
      if (+iframe.getAttribute('data-loads') > 0) {
        onFrameLoad(iframe);
      } else {
        var frame = iframe.closest('[data-ez-sv-frame]');
        setTimeout(function () {
          if (!(+iframe.getAttribute('data-loads') > 0)) frame.classList.add('is-slow');
        }, 12000);
      }
    });

    document.querySelectorAll('[data-ez-service] a[href^="#ez-sv-faq-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (openFaq(a.getAttribute('href'))) {
          e.preventDefault();
          if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
        }
      });
    });

    if (location.hash) openFaq(location.hash);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
